// extracted by mini-css-extract-plugin
export default {"heading":"Heading4_heading__1hLzA"};